namespace Portico.Models.Enterprise {
	import psge = apigateway.enums;
	import psgm = apigateway.models;

    export interface IContact {
        id: number;
		type: string | number;
        firstName: string;
        lastName: string;
		occupation: string;
		isActive: boolean;

		addresses: Address[];
		emailAddresses: EmailAddress[];
		phoneNumbers: PhoneNumber[];
		webAddresses: WebAddress[];

		addAddress(index?: number): Address;
		addEmailAddress(index?: number): EmailAddress;
		addPhoneNumber(index?: number): PhoneNumber;
		addWebAddress(index?: number): WebAddress;
	}

    export class Contact implements IContact {
		id: number;
		type: string | number;
		firstName: string;
		lastName: string;
		occupation: string;
		isActive: boolean;

		addresses: Address[];
		emailAddresses: EmailAddress[];
		phoneNumbers: PhoneNumber[];
		webAddresses: WebAddress[];

        constructor(obj?: IContact) {
            this.id = null;
			this.firstName = '';
			this.lastName = '';
			this.occupation = '';
			this.isActive = true;
			this.addresses = [];
			this.emailAddresses = [];
			this.phoneNumbers = [];
			this.webAddresses = [];

            if (obj) {
                this.id = obj.id || null;
                this.firstName = obj.firstName || '';
				this.lastName = obj.lastName || '';
				this.occupation = obj.occupation || '';
				this.isActive = obj.isActive || true;

				if (obj.addresses) {
					for (const address of obj.addresses) {
						this.addresses.push(new Address(address));
					}
				}

				if (obj.emailAddresses) {
					for (const emailAddress of obj.emailAddresses) {
						this.emailAddresses.push(new EmailAddress(emailAddress));
					}
				}

				if (obj.phoneNumbers) {
					for (const phoneNumber of obj.phoneNumbers) {
						this.phoneNumbers.push(new PhoneNumber(phoneNumber));
					}
				}

				if (obj.webAddresses) {
					for (const webAddress of obj.webAddresses) {
						this.webAddresses.push(new WebAddress(webAddress));
					}
				}
            }
        }

		addAddress(index: number = null): Address {
			const length = this.addresses.length;

			if (index && index < length) {
				return this.addresses[index];
			}

			const address = new Address();
			this.addresses.push(address);
			return address;
		}

		addEmailAddress(index: number = null): EmailAddress {
			const length = this.emailAddresses.length;

			if (index && index < length) {
				return this.emailAddresses[index];
			}

			const emailAddress = new EmailAddress();
			this.emailAddresses.push(emailAddress);
			return emailAddress;
		}

		addPhoneNumber(index: number = null): PhoneNumber {
			const length = this.phoneNumbers.length;

			if (index && index < length) {
				return this.phoneNumbers[index];
			}

			const phoneNumber = new PhoneNumber();
			this.phoneNumbers.push(phoneNumber);
			return phoneNumber;
		}

		addWebAddress(index: number = null): WebAddress {
			const length = this.webAddresses.length;

			if (index && index < length) {
				return this.webAddresses[index];
			}

			const webAddress = new WebAddress();
			this.webAddresses.push(webAddress);
			return webAddress;
		}

		mapToEnterpriseCoordinatorContact() : psgm.EnterpriseCoordinatorSharedContactUpsearchModel {
			return {
				addresses: this.addresses &&
					this.addresses.length > 0
					? _.map(this.addresses, addr => {
						return addr.mapToEnterpriseCoordinatorAddress();
					}) : [],
				emailAddresses: this.emailAddresses &&
					this.emailAddresses.length > 0
					? _.map( this.emailAddresses, email => {
						return email.mapToEnterpriseCoordinatorEmailAddress();
					}) : [],
				phoneNumbers:  this.phoneNumbers &&
					this.phoneNumbers.length > 0
					? _.map( this.phoneNumbers, ph => {
						return ph.mapToEnterpriseCoordinatorPhoneUpsearchModel();
					}) : [],
				webAddresses: this.webAddresses &&
					this.webAddresses.length > 0
					? _.map( this.webAddresses, webAddr => {
						return webAddr.mapToEnterpriseCoordinatorWebAddress();
					}) : [],
				contactId: this.id,
				contactType: typeof this.type === 'number' ? this.type : psge.RoleType[this.type],
				firstName: this.firstName,
				lastName: this.lastName,
				occupationDescription: this.occupation
			} as psgm.EnterpriseCoordinatorSharedContactUpsearchModel
        }
	}
}
